import {combineReducers} from 'redux'

import data from '../data.json'

const accommodationOptions = (state = data.accommodationOptions, action) => {
  switch (action.type) {
    default:
      return state
  }
}

const accommodationOptionsFilter = (state = 'SHOW_ALL', action) => {
  switch (action.type) {
    case 'SET_ACCOMMODATION_FILTER':
      return action.filter
    default:
      return state
  }
}

const accommodation = combineReducers({
  accommodationOptions,
  accommodationOptionsFilter,
})

export default accommodation

const getAllAccommodationOptions = state => {
  let accommodationOptionList = []
  for (var key in state.accommodationOptions) {
    if (state.accommodationOptions.hasOwnProperty(key)) {
      accommodationOptionList.push(state.accommodationOptions[key])
    }
  }
  return accommodationOptionList
}

export const getFilteredAccommodationOptions = state => {
  let accommodationOptionList = getAllAccommodationOptions(state)
  switch (state.accommodationOptionsFilter) {
    case 'SHOW_ALL':
      break
    case 'SHOW_BOOKINGDOTCOM':
      accommodationOptionList = accommodationOptionList.filter(item => {
        return item.bookingDotCom
      })
      break
    default:
  }
  return accommodationOptionList
}



// WEBPACK FOOTER //
// ./src/reducers/accommodation.js